import React from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  HeadingText,
  BodyText,
} from '@paypalcorp/pp-react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';
import style from './noSearchResults.less';

const NoSearchResults = ({ header, subHeader, imageUrl }) => {
  return (
    <Container className={style.noResultContainer}>
      <Row noGutters={true}>
        <Col sm={12} className={style.noResultCol}>
          <img alt='noSearchResults' src={imageUrl} width='127' height='110' />
        </Col>
        <Col sm={12}>
          <HeadingText size='sm'>{header}</HeadingText>
        </Col>
        <Col sm={12} className={style.noResultCol}>
          <BodyText>{subHeader}</BodyText>
        </Col>
      </Row>
    </Container>
  );
};

NoSearchResults.propTypes = {
  header: PropTypes.string.isRequired,
  subHeader: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

NoSearchResults.defaultProps = {
  imageUrl:
    'https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-magnifying-glass-white.svg',
};

export { NoSearchResults };
